module.exports = __webpack_public_path__ + "static/media/a4.9974874e.png";